import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Card, Progress, Icon, Radio, Divider } from "antd";
// Styles
import { Wrapper, H4 } from "./styles";

import colors from "../../theme/colors";

import { Bar, Chart } from 'react-chartjs-2';

// Hooks
import useHistorical from '../../hooks/useHistorical';

//import multilanguage library
import { useTranslation } from 'react-i18next'

const INITIAL_SUMMARY = {
    summary: 0,
    furnace: 0,
    quenching: 0,
    tempered: 0,
    total: 0
}

const INITIAL_CHARTS = {
  labels: [],
  data_furnace_time: [],
  data_furnace_time_limit: [],
  data_furnace_temp: [],
  data_furnace_temp_limit: [],
  colors_furnace_time: [],
  colors_furnace_temp: [],
  radius_furnace_time: [],
  radius_furnace_temp: [],

  data_quenching_temp: [],
  data_quenching_temp_limit: [],
  data_quenching_agit: [],
  data_quenching_agit_limit: [],
  colors_quenching_temp: [],
  colors_quenching_agit: [],
  radius_quenching_temp: [],
  radius_quenching_agit: [],

  data_tempered_time: [],
  data_tempered_time_limit: [],
  data_tempered_temp: [],
  data_tempered_temp_limit: [],
  colors_tempered_time: [],
  colors_tempered_temp: [],
  radius_tempered_time: [],
  radius_tempered_temp: []
}

const INITIAL_RADIO = {
  furnace: {
    temp: "line",
    time: "bar"
  },
  quenching: {
    agitation: "bar",
    temp: "line"
  },
  tempered: {
    temp: "line",
    time: "bar"
  },
}

const chartColors = {
  time: 'rgba(54, 162, 235, 0.3)',
  temp: 'rgba(255, 159, 64, 0.4)',
  error: 'rgba(255, 99, 132, 0.5)'
}

const RenderOf = ({ OF }) => {
    const [summary, setSummary] = useState(INITIAL_SUMMARY);
    const [chartValues, setChartsValue] = useState(INITIAL_CHARTS);

    const [radioOfType, setRadioOfType] = useState(INITIAL_RADIO);

    //To translate text
    const { t } = useTranslation();
    
    const { setPiece } = useHistorical();

    //Chart images reference to download
    const image_down_furnace_chart = useRef(null);
    const image_down_quenching_chart = useRef(null);
    const image_down_tempered_chart = useRef(null);

  useEffect(() => {
    if (OF) {
      let data = returnData(OF.pieces);
      setSummary(data.summary);
      setChartsValue(data.charts);
    }
  }, [OF]);

  useEffect(() => {
    Chart.pluginService.register({
      afterDraw: function (chart, easing) {
        //if chart il loaded 100%
        if (easing === 1) {
          //get url of canvas
          let canvas = chart.canvas;
          canvas.style.backgroundColor = "white"; //background white to good visualize
          let url_base64jp = canvas.toDataURL("image/jpg", 1.0);
          
          if (canvas.id === "0" && image_down_furnace_chart.current) image_down_furnace_chart.current.href = url_base64jp
          else if (canvas.id === "1" && image_down_quenching_chart.current) image_down_quenching_chart.current.href = url_base64jp
          else if (canvas.id === "2" && image_down_tempered_chart.current) image_down_tempered_chart.current.href = url_base64jp

          //On click select as deafault PIECE
          canvas.onclick = function(evt) {

            //If chart onclick isn't 0,1,2 this function not works
            if (evt.target.id > 2) return;

            var activePoints = chart.getElementsAtEvent(evt);
            if (activePoints[0] && OF) {
              var idx = activePoints[0]['_index'];
              setPiece(OF.pieces[idx]);
            }
          };
          

        }
      }, 
      
    });
  }, [OF]);

  const returnData = pieces => {
    let total = pieces.length || 0,
        furnace = 0,
        quenching = 0,
        tempered = 0,
        summary = 0,
        charts = {
          labels: [],
          data_furnace_time: [],
          data_furnace_time_limit: [],
          data_furnace_temp: [],
          data_furnace_temp_limit: [],
          colors_furnace_time: [],
          colors_furnace_temp: [],
          radius_furnace_time: [],
          radius_furnace_temp: [],

          data_quenching_temp: [],
          data_quenching_temp_limit: [],
          data_quenching_agit: [],
          data_quenching_agit_limit: [],
          colors_quenching_temp: [],
          colors_quenching_agit: [],
          radius_quenching_temp: [],
          radius_quenching_agit: [],

          data_tempered_time: [],
          data_tempered_time_limit: [],
          data_tempered_temp: [],
          data_tempered_temp_limit: [],
          colors_tempered_time: [],
          colors_tempered_temp: [],
          radius_tempered_time: [],
          radius_tempered_temp: []
        }

    pieces.forEach(el => {

        let summary_add = 0;
        //Variables to summary
        if (el.furnace.stateTemp === 1 && el.furnace.stateTime === 1) { furnace++; summary_add++; }
        if (el.quenching.stateTemp === 1 && el.quenching.stateAgit === 1) { quenching++; summary_add++; }
        if (el.tempered.stateTemp === 1 && el.tempered.stateTime === 1) { tempered++; summary_add++; }

        //FURNACE data
        if (el.furnace.stateTemp === 1) {
          charts.colors_furnace_temp.push(chartColors.temp)
          charts.radius_furnace_temp.push(1)
        } else {
          charts.colors_furnace_temp.push(chartColors.error)
          charts.radius_furnace_temp.push(3)
        }

        if (el.furnace.stateTime === 1) {
          charts.colors_furnace_time.push(chartColors.time)
          charts.radius_furnace_time.push(1)
        } else {
          charts.colors_furnace_time.push(chartColors.error)
          charts.radius_furnace_time.push(3)
        }

        //QUENCHING data
        if (el.quenching.stateTemp === 1) {
          charts.colors_quenching_temp.push(chartColors.temp)
          charts.radius_quenching_temp.push(1)
        } else {
          charts.colors_quenching_temp.push(chartColors.error)
          charts.radius_quenching_temp.push(3)
        }

        if (el.quenching.stateAgit === 1) {
          charts.colors_quenching_agit.push(chartColors.time)
          charts.radius_quenching_agit.push(1)
        } else {
          charts.colors_quenching_agit.push(chartColors.error)
          charts.radius_quenching_agit.push(3)
        }

        //TEMPERED data
        if (el.tempered.stateTemp === 1) {
          charts.colors_tempered_temp.push(chartColors.temp)
          charts.radius_tempered_temp.push(1)
        } else {
          charts.colors_tempered_temp.push(chartColors.error)
          charts.radius_tempered_temp.push(3)
        }

        if (el.tempered.stateTime === 1) {
          charts.colors_tempered_time.push(chartColors.time)
          charts.radius_tempered_time.push(1)
        } else {
          charts.colors_tempered_time.push(chartColors.error)
          charts.radius_tempered_time.push(3)
        }

        //If all status is OK
        if (summary_add === 3) summary++;

        //Charts values
        charts.labels.push(el.number)
        //Furnace
        charts.data_furnace_time.push(el.furnace.time/60)
        charts.data_furnace_time_limit.push(OF.design.recommendation.furnace_time/60)
        charts.data_furnace_temp.push(el.furnace.tempAverage)
        charts.data_furnace_temp_limit.push(OF.design.furnace.temperature)
        //Quenching
        charts.data_quenching_agit.push(el.quenching.agitation)
        charts.data_quenching_agit_limit.push(OF.design.quenching.agitation_level)
        charts.data_quenching_temp.push(el.quenching.tempAverage)
        charts.data_quenching_temp_limit.push(OF.design.quenching.bath_temperature)
        //Tempered
        charts.data_tempered_time.push(el.tempered.time/60)
        charts.data_tempered_time_limit.push(OF.design.recommendation.tempered_time/60)
        charts.data_tempered_temp.push(el.tempered.tempAverage)
        charts.data_tempered_temp_limit.push(OF.design.tempered.temperature)

    });

    return { 
      summary: {
        summary: summary,
        furnace: furnace,
        quenching: quenching,
        tempered: tempered,
        total: total
      },
      charts: charts
    }
  }

  const RenderProgressQuad = ({title, value, total}) => {
        return (
            <Col xl={6} lg={6} md={6}  style={{textAlign: "center", paddingTop: 0}}>
                <Card size="small">
                    <H4>{title}</H4>
                    <Progress type="circle" percent={parseInt(value*100/total)} width={40} status="normal" strokeColor={colors.primary} />
                    <p style={{ margin: 0 }}>{t('historical.percent_of', {value: value, total: total})}</p>
                </Card>
            </Col>
        );
  }

  const RenderCardExtra = (design_label_1, design_label_2, radioType1_1, radioType1_2, radioType2_1, radioType2_2, keyImage, imageRef) => {
    return [
      <span key={radioType1_1+"_1"}>
        {design_label_1} 
        <Radio.Group value={radioOfType[radioType1_1][radioType1_2]} size="small" onChange={(val) => changeRadioOf(radioType1_1, radioType1_2, val)}>
          <Radio.Button value="bar" ><Icon type="bar-chart" /></Radio.Button>
          <Radio.Button value="line" ><Icon type="line-chart" /></Radio.Button>
        </Radio.Group>
      </span>,
      <Divider  key={radioType1_1+"_2"} type="vertical"></Divider>,
      <span key={radioType1_1+"_3"}>
        {design_label_2} 
        <Radio.Group value={radioOfType[radioType2_1][radioType2_2]} size="small" onChange={(val) => changeRadioOf(radioType2_1, radioType2_2, val)}>
          <Radio.Button value="bar" ><Icon type="bar-chart" /></Radio.Button>
          <Radio.Button value="line" ><Icon type="line-chart" /></Radio.Button>
        </Radio.Group>
      </span>,
      <Divider key={radioType1_1+"_4"} type="vertical"></Divider>,
      <a key={keyImage} src="image.png" ref={imageRef} href="" download><Icon type="download" /></a>
    ];
  }

  const RenderDatasets = (data1, label1, color1, type1, dataLimit1, labelLimit1, radius1, data2, label2, color2, type2, dataLimit2, labelLimit2, radius2) => {
    return [{
          data: data1,
          label: label1,
          backgroundColor: color1,
          borderColor: color1,

          // This binds the dataset to the left y axis
          yAxisID: 'left-y-axis',
          type: type1,
          fill: false,
          pointRadius: radius1
      },
      {
          data: dataLimit1,
          label: labelLimit1,
          backgroundColor: 'rgba(54, 162, 235, 0)',
          borderColor: 'rgba(155, 155, 155, .8)',
          borderDash: [10, 5],

          // This binds the dataset to the left y axis
          yAxisID: 'left-y-axis',
          type: 'line',
          fill: false,
          pointRadius: 0,
          borderWidth: 1,
          //pointStyle: "circle",
      },
      {
          data: data2,
          label: label2,
          backgroundColor: color2,
          borderColor: color2,

          // This binds the dataset to the right y axis
          yAxisID: 'right-y-axis',
          type: type2,
          fill: false,
          pointRadius: radius2
      },
      {
          data: dataLimit2,
          label: labelLimit2,
          backgroundColor: 'rgba(54, 162, 235, 0)',
          borderColor: 'rgba(155, 0, 0, .8)',
          borderDash: [10, 5],

          // This binds the dataset to the left y axis
          yAxisID: 'right-y-axis',
          type: 'line',
          fill: false,
          pointRadius: 0,
          borderWidth: 1
      }
    ]
  }

  const RenderChartOF = ({keyCard, keyChart, title, RenderDatasets, RenderCardExtra, Labels, labelXaxis, labelYaxisLeft, labelYaxisRight, ticks, }) => {
    return (
      <Card key={keyCard} size="small" title={title} extra={RenderCardExtra}>
        <Bar
          id={keyChart}
          key={keyChart}
          width={100}
          height={30}
          data={{
            datasets: RenderDatasets,
            labels: Labels
          }}
          options={{
            animation: false,
            scales: {
                xAxes: [{
                  id: 'x-axis',
                  scaleLabel: {
                    display: true,
                    labelString: labelXaxis
                  },
                  ticks: {
                    fontSize: 8
                  }        
                }],
                yAxes: [{
                    id: 'left-y-axis',
                    type: 'linear',
                    position: 'left',
                    /*ticks: {
                      min: 0,
                      stepSize: null,
                    },*/
                    ticks: ticks[0],
                    gridLines: {
                      display: false
                    },
                    scaleLabel: {
                      display: true,
                      labelString: labelYaxisLeft,
                    },                             
                }, {
                    id: 'right-y-axis',
                    type: 'linear',
                    position: 'right',
                    /*ticks: {
                      //max: parseInt(Math.max(...chartValues.data_furnace_temp)+100),
                      //min: parseInt(Math.min(...chartValues.data_furnace_temp)-50),
                      //stepSize: 50
                      min: 0
                    },*/
                    ticks: ticks[1],
                    gridLines: {
                      display: false
                    },
                    scaleLabel: {
                      display: true,
                      labelString: labelYaxisRight
                    }
                }]
            },
            legend: {
              labels: {
                fontSize: 10,
                usePointStyle: true,
              }
            },
            
          }}
          // options={{ maintainAspectRatio: false }}
        />
      </Card>
    )
  }

  //Change type of chart (line or bar)
  const changeRadioOf = (fase, type, val) => {
    let newRadio = Object.assign({}, radioOfType);
    newRadio[fase][type] = val.target.value;
    setRadioOfType(newRadio)
  }

  return (
    <Wrapper>
        <Row style={{ margin: 0 }} gutter={[16, 16]}>
            <RenderProgressQuad title={t('headers.historical.of_resume')} value={summary.summary} total={summary.total} />
            <RenderProgressQuad title={t('phase.furnace')} value={summary.furnace} total={summary.total} />
            <RenderProgressQuad title={t('phase.quenching')} value={summary.quenching} total={summary.total} />
            <RenderProgressQuad title={t('phase.tempered')} value={summary.tempered} total={summary.total} />
        </Row>
        <Row style={{ margin: 0 }} gutter={[16, 16]}>
            <Col xl={24} lg={24} md={24} >
                <RenderChartOF 
                  keyCard="furnace_card"
                  keyChart={0}
                  title={t('phase.furnace')}
                  RenderDatasets={RenderDatasets(chartValues.data_furnace_time, t('historical.legend.time_in_furnace'), chartValues.colors_furnace_time, 
                                                    radioOfType.furnace.time, chartValues.data_furnace_time_limit, t('historical.limits.design_time' , {value: OF && OF.design.recommendation.furnace_time/60}),
                                                    chartValues.radius_furnace_time,
                                                    chartValues.data_furnace_temp, t('historical.legend.avg_temp'), chartValues.colors_furnace_temp, 
                                                    radioOfType.furnace.temp, chartValues.data_furnace_temp_limit, t('historical.limits.design_temp', {value: OF && OF.design.furnace.temperature}),
                                                    chartValues.radius_furnace_temp)}

                  RenderCardExtra={RenderCardExtra(t('historical.limits.design_time' , {value: OF && OF.design.recommendation.furnace_time/60}), t('historical.limits.design_temp', {value: OF && OF.design.furnace.temperature}), 
                                                    "furnace", "time", "furnace", "temp", "image_prueba", image_down_furnace_chart)}
                  Labels={chartValues.labels}
                  labelXaxis={t('historical.labels.pieces')}
                  labelYaxisLeft={t('historical.legend.time_in_furnace')}
                  labelYaxisRight={t('historical.legend.avg_temp')}
                  ticks={[{ min: 0 }, { min: parseInt(Math.min(...chartValues.data_furnace_temp)-50), max: parseInt(Math.max(...chartValues.data_furnace_temp)+100) }]}
                />
            </Col>
        </Row>
        <Row style={{ margin: 0 }} gutter={[16, 16]}>
            <Col xl={24} lg={24} md={24} >
                <RenderChartOF 
                  keyCard="quenching_card"
                  keyChart={1}
                  title={t('phase.quenching')}
                  RenderDatasets={RenderDatasets(chartValues.data_quenching_temp, t('historical.legend.avg_temp'), chartValues.colors_quenching_temp, 
                                                    radioOfType.quenching.temp, chartValues.data_quenching_temp_limit, t('historical.limits.design_temp', {value: OF && OF.design.quenching.bath_temperature}),
                                                    chartValues.radius_quenching_temp,
                                                    chartValues.data_quenching_agit, t('historical.legend.agitation_level'), chartValues.colors_quenching_agit, 
                                                    radioOfType.quenching.agitation, chartValues.data_quenching_agit_limit, t('historical.limits.agitation_level', {value: OF && OF.design.quenching.agitation_level}),
                                                    chartValues.radius_quenching_agit)}

                  RenderCardExtra={RenderCardExtra(t('historical.limits.design_temp', {value: OF && OF.design.quenching.bath_temperature}), t('historical.limits.agitation_level', {value: OF && OF.design.quenching.agitation_level}), 
                                                    "quenching", "temp", "quenching", "agitation", "image_quenching", image_down_quenching_chart)}
                  Labels={chartValues.labels}
                  labelXaxis={t('historical.labels.pieces')}
                  labelYaxisLeft={t('historical.legend.avg_temp')}
                  labelYaxisRight={t('historical.legend.agitation_level')}
                  ticks={[{min: 0, max: parseInt(Math.max(...chartValues.data_quenching_temp)+10) }, {min: 0, max:4, stepSize: 1}]}
                />
            </Col>
        </Row>
        <Row style={{ margin: 0 }} gutter={[16, 16]}>
            <Col xl={24} lg={24} md={24} >
                <RenderChartOF 
                  keyCard="tempered_card"
                  keyChart={2}
                  title={t('phase.tempered')}
                  RenderDatasets={RenderDatasets(chartValues.data_tempered_time, t('historical.legend.time_in_furnace'), chartValues.colors_tempered_time, 
                                                    radioOfType.tempered.time, chartValues.data_tempered_time_limit, t('historical.limits.design_time' , {value: OF && OF.design.recommendation.tempered_time/60}),
                                                    chartValues.radius_tempered_time,
                                                    chartValues.data_tempered_temp, t('historical.legend.avg_temp'), chartValues.colors_tempered_temp, 
                                                    radioOfType.tempered.temp, chartValues.data_tempered_temp_limit, t('historical.limits.design_temp', {value: OF && OF.design.tempered.temperature}),
                                                    chartValues.radius_tempered_temp)}
                  RenderCardExtra={RenderCardExtra(t('historical.limits.design_time' , {value: OF && OF.design.recommendation.tempered_time/60}), t('historical.limits.design_temp', {value: OF && OF.design.tempered.temperature}), 
                                                    "tempered", "time", "tempered", "temp", "image_prueba", image_down_tempered_chart)}
                  Labels={chartValues.labels}
                  labelXaxis={t('historical.labels.pieces')}
                  labelYaxisLeft={t('historical.legend.time_in_furnace')}
                  labelYaxisRight={t('historical.legend.avg_temp')}
                  ticks={[{ min: 0 }, { min: parseInt(Math.min(...chartValues.data_tempered_temp)-50), max: parseInt(Math.max(...chartValues.data_tempered_temp)+100) }]}
                />
            </Col>
        </Row>
    </Wrapper>
  );
};
export default RenderOf;
